import { http } from "./http.js";

async function getCarrier(resource, id) {
  const response = await http.get(`/${resource}/${id === "0" ? "new" : id}`);
  return response;
}

async function updateCarrier(resource, id, carrier) {
  const response = await http.put(`/${resource}/${id}`, carrier);
  return response;
}

async function createCarrier(resource, carrier) {
  const response = await http.post(`/${resource}`, carrier);
  return response;
}

async function changeRemovedState(resource, id, isRemoved) {
  const response = await http.patch(
    `/${resource}/${id}/rpc/change-removed-state`,
    {
      value: !isRemoved,
    },
  );
  return response;
}

export { getCarrier, updateCarrier, createCarrier, changeRemovedState };
